import styled from "styled-components";

export const ContentWrapper = styled.div`
  width: 70%;
  margin: 0 auto;
  @media (max-width: 1300px) {
    width: 80%;
  }
  @media (max-width: 800px) {
    width: 90%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const MySection = styled.section`
  min-height: calc(100vh - 99px);
  display: flex;
  scroll-margin-top: 99px;
  -webkit-scroll-margin-top: 99px;
  -moz-scroll-margin-top: 99px;
  -ms-scroll-margin-top: 99px;
  :first-child {
    margin-top: 99px;
  }
  @media (max-width: 1000px) {
    scroll-margin-top: 77px;
    -webkit-scroll-margin-top: 77px;
    -moz-scroll-margin-top: 77px;
    -ms-scroll-margin-top: 77px;
    :first-child {
      margin-top: 77px;
    }
  }
  filter: ${({ isOpen }) => (isOpen ? "blur(4px)" : "none")};
`;

export const FirstSectionWrapper = styled.div`
  height: 100%;
  margin: auto 0;
`;

export const ChildFirstSectionWrapper = styled.div`
  padding-top: 4rem;
  padding-bottom: 4rem;
  @media (max-width: 1000px) {
    padding-top: 2rem;
    padding-bottom: 10rem;
  }
`;

export const Introduction = styled.p`
  font-size: 14px;
  opacity: 50%;
  @media (max-width: 1000px) {
    font-size: 10px;
  }
  /* @media (max-width: 600px) {
    font-size: 8px;
  } */
`;

export const HelloMyNameIs = styled.p`
  margin-left: 38px;
  margin-top: 30px;
  color: var(--main-color);
  font-size: 16px;
  margin-bottom: 5px;
  @media (max-width: 1000px) {
    font-size: 14px;
  }
  /* @media (max-width: 600px) {
    font-size: 10px;
  } */
`;

export const MyName = styled.p`
  /* display: inline-block; */
  margin-left: 38px;
  font-size: 64px;
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  .dot {
    color: var(--main-color);
  }
  @media (max-width: 1300px) {
    font-size: 42px;
  }
  @media (max-width: 600px) {
    /* font-size: 38px; */
  }
`;

export const BuildThingsFor = styled.p`
  /* display: inline-block; */
  margin-left: 38px;
  margin-bottom: 43px;
  font-size: 64px;
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  opacity: 45%;
  @media (max-width: 1600px) {
    font-size: 36px;
  }
  @media (max-width: 1300px) {
    font-size: 32px;
  }
  @media (max-width: 1000px) {
    font-size: 26px;
  }
  @media (max-width: 600px) {
    font-size: 18px;
  }
`;

export const MyGoal = styled.p`
  margin-left: 38px;
  margin-bottom: 55px;
  font-size: 16px;
  width: 60%;
  @media (max-width: 1000px) {
    font-size: 12px;
    width: 70%;
  }
  @media (max-width: 600px) {
    /* font-size: 10px; */
    width: 90%;
  }
`;

export const ContactButton = styled.button`
  all: unset;
  margin-left: 38px;
  text-transform: uppercase;
  font-size: 18px;
  color: var(--main-color);
  border: solid 2px var(--main-color);
  padding: 14px;
  cursor: pointer;
  margin-bottom: 30px;
  text-align: center;
  @media (max-width: 1300px) {
    font-size: 16px;
    padding: 12px;
  }
  @media (max-width: 600px) {
    /* font-size: 14px; */
    /* padding: 12px; */
  }
`;

//---------------------------------Section 2-------------------01. About
export const SecondSectionWrapper = styled.div`
  height: 80%;
  margin: auto 0;
`;

export const ChildSecondSectionWrapper = styled.div`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;

export const AboutMe = styled.p`
  display: inline-block;
  font-size: 14px;
  opacity: 50%;
  @media (max-width: 1000px) {
    font-size: 10px;
  }
`;

export const AboutTitleWrapper = styled.div`
  margin-left: 38px;
  margin-top: 30px;
  display: flex;
  align-items: center;
`;

export const AboutTitle = styled.p`
  font-size: 20px;
  color: var(--main-color);
  span {
    opacity: 65%;
    margin-left: 20px;
    font-size: 40px;
    font-family: "Raleway", sans-serif;
  }
  @media (max-width: 600px) {
    font-size: 14px;
    span {
      font-size: 36px;
    }
  }
`;

export const HorizLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: #fff;
  margin-left: 75px;
  opacity: 20%;
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const ParaWrapper = styled.div``;

export const FirstPara = styled.p`
  margin-left: 38px;
  margin-top: 41px;
  font-size: 14px;
  @media (max-width: 800px) {
    font-size: 12px;
  }
`;

export const SecondPara = styled.p`
  margin-left: 38px;
  margin-top: 25px;
  margin-bottom: 25px;
  font-size: 14px;
  @media (max-width: 800px) {
    font-size: 12px;
  }
`;

export const ThridPara = styled.p`
  margin-left: 38px;
  font-size: 14px;
  @media (max-width: 800px) {
    font-size: 12px;
  }
`;

export const TechsWrapper = styled.div`
  margin-left: 38px;
  margin-top: 20px;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: start;
  text-wrap: nowrap;
  /* flex: 0 1 auto; */
  span {
    display: flex;
    flex-direction: column;
    p:not(:last-child) {
      margin-bottom: 5px;
    }
  }
  margin-bottom: 30px;
  @media (max-width: 800px) {
    font-size: 12px;
  }
  /* @media (max-width: 600px) {
    span {
      margin-right: 50px;
    }
  }
  @media (max-width: 450px) {
    span {
      margin-right: 30px;
    }
  } */
`;

//---------------------------Section 02. Things I've worked on...--------------------------------
export const ThirdSectionWrapper = styled.div`
  min-height: 80%;
  margin: auto 0;
`;

export const ChildThirdSectionWrapper = styled.div`
  padding-top: 2rem;
  padding-bottom: 10rem;
`;

export const WorkedOnTitleWrapper = styled.div`
  margin-left: 38px;
  margin-top: 30px;
  display: flex;
  align-items: center;
`;

export const WorkedOnTitle = styled.p`
  font-size: 20px;
  color: var(--main-color);
  span {
    opacity: 65%;
    margin-left: 20px;
    font-size: 40px;
    font-family: "Raleway", sans-serif;
  }
  @media (max-width: 600px) {
    font-size: 14px;
    span {
      font-size: 36px;
    }
  }
`;

//---------------------------Section 03. Case Study...--------------------------------
export const CaseStudyWrapper = styled.div`
  height: 90%;
  margin: auto 0;
`;

export const CaseStudyChildWrapper = styled.div`
  padding-top: 6rem;
  padding-bottom: 2rem;
`;

export const CaseStudyTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
  > * + * {
    margin-top: 10px;
  }
  margin-bottom: 30px;
`;

export const CaseStudyTitle = styled.p`
  font-size: 20px;
  color: var(--main-color);
  span {
    opacity: 80%;
    margin-left: 20px;
    font-size: 40px;
    font-family: "Raleway", sans-serif;
  }
`;

export const CaseStudySubTitle = styled.p`
  font-size: 16px;
  span {
    color: var(--main-color);
  }
`;

export const CaseStudyDate = styled.p`
  font-size: 12px;
  color: #919191;
`;

//---------------------------Section 04. Contact...--------------------------------
export const ContactSectionWrapper = styled.div`
  height: 80%;
  margin: auto 0;
`;

export const ChildContactSectionWrapper = styled.div`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;

export const Contact = styled.p`
  font-size: 14px;
  opacity: 50%;
  @media (max-width: 1000px) {
    font-size: 10px;
  }
`;

export const NoContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const WhatsNext = styled.p`
  margin-top: 30px;
  color: var(--main-color);
  font-size: 16px;
  text-align: center;
  @media (max-width: 1000px) {
    font-size: 14px;
  }
`;

export const GetInTouch = styled.p`
  margin-bottom: 43px;
  font-size: 64px;
  font-family: "Raleway", sans-serif;
  font-weight: 600;
  opacity: 65%;
  text-align: center;
  @media (max-width: 1300px) {
    font-size: 42px;
  }
  @media (max-width: 600px) {
    /* font-size: 34px; */
  }
`;

export const ContactText = styled.p`
  margin-bottom: 55px;
  font-size: 14px;
  width: 70%;
  text-align: center;
  @media (max-width: 1000px) {
    font-size: 13px;
    width: 90%;
  }
`;

export const SayHelloButton = styled.button`
  all: unset;
  text-transform: capitalize;
  font-size: 18px;
  color: var(--main-color);
  border: solid 2px var(--main-color);
  padding: 14px;
  cursor: pointer;
  margin-bottom: 30px;
  text-align: center;
  @media (max-width: 1300px) {
    font-size: 16px;
    padding: 12px;
  }
  @media (max-width: 600px) {
    /* font-size: 14px; */
    /* padding: 12px; */
  }
`;

export const DesignByWrapper = styled.div`
  position: absolute;
  bottom: 30px;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const DesignedBy = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  text-align: center;
  @media (max-width: 800px) {
    font-size: 12px;
  }
  :hover {
    color: var(--main-color);
  }
`;
